import { useEffect } from 'react';

import { preloadModules } from './lazyPreload';

export function usePreloadModules(modules: (() => Promise<any>)[]) {
  useEffect(() => {
    preloadModules(modules);
  }, [modules]);
}
